import React from "react";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";
import { glassCardSx, NJIM } from "../../theme/njimTheme";

const MobilePaymentStatus: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: NJIM.muted,
        p: 2,
      }}
    >
      <Box
        sx={{
          ...glassCardSx,
          mb: 0,
          width: "100%",
          maxWidth: 420,
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            display: "grid",
            placeItems: "center",
            bgcolor: NJIM.successWash,
            mx: "auto",
            mb: 2,
          }}
        >
          <CheckCircleOutlineIcon sx={{ fontSize: 40, color: NJIM.success }} />
        </Box>
        <Typography sx={{ fontSize: 20, fontWeight: 700, color: NJIM.ink, mb: 1 }}>
          {t("mobilePayment.title", { lng: "en" })}
        </Typography>
        <Typography sx={{ fontSize: 14, color: NJIM.textSecondary, mb: 2.5 }}>
          {t("mobilePayment.message", { lng: "en" })}
        </Typography>
        <Box sx={{ height: 1, bgcolor: NJIM.border, my: 2 }} />
        <Typography sx={{ fontSize: 20, fontWeight: 700, color: NJIM.ink, mb: 1 }} dir="rtl">
          {t("mobilePayment.title", { lng: "ar" })}
        </Typography>
        <Typography sx={{ fontSize: 14, color: NJIM.textSecondary }} dir="rtl">
          {t("mobilePayment.message", { lng: "ar" })}
        </Typography>
      </Box>
    </Box>
  );
};

export default MobilePaymentStatus;
